import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/img/RTLHU_Belepes_Hatterkep_2048x2048.jpg'
import _imports_1 from '../../assets/img/rtlplusz_auth.png'


const _hoisted_1 = { style: {"display":"contents"} }
const _hoisted_2 = {
  key: 0,
  class: "login-backdrop"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "login-backdrop__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "rtl.hu",
    class: "login-backdrop__left-image"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "login-backdrop__right" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "auth auth--login" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "auth__left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Elfelejtett jelszó"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "rtlmost",
      class: "login-title__logo"
    })
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "auth__text" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "A további információkat és a jelszó változtatáshoz szükséges linket elküldtük a megadott e-mail címre.", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "auth__text"
}
const _hoisted_16 = {
  key: 1,
  class: "auth__text"
}
const _hoisted_17 = {
  key: 0,
  class: "form-errors"
}
const _hoisted_18 = { class: "form-errors__error" }
const _hoisted_19 = {
  key: 1,
  class: "auth__form-group"
}
const _hoisted_20 = { class: "auth__form-group" }
const _hoisted_21 = { class: "auth__form-group" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "auth__form-group auth__row" }
const _hoisted_24 = { class: "auth__col auth__col--back-to-login" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Vissza a belépéshez")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["auth__container", { 'auth__container--center': !_ctx.showImage }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_ctx.invalidTokenError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.getFieldErrorValue('error')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "auth__button auth__button--primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args)))
                  }, "Újrakezdem")
                ]))
              : (_ctx.resetEmailSent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.resetData.passwordResetToken)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Kérlek add meg az új jelszavad az alábbi űrlapon. Sikeres változtatás után automatikusan átirányítunk a bejelentkező felületre."))
                      : (_openBlock(), _createElementBlock("p", _hoisted_16, "Elfelejtetted a jelszavadat? Semmi gond, a regisztrációkor használt email címedre küldünk egy linket, amire kattintva megadhatsz egy újat.")),
                    _createElementVNode("form", {
                      class: "auth__form",
                      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
                    }, [
                      (_ctx.hasFieldError('error'))
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                            _createElementVNode("li", _hoisted_18, _toDisplayString(_ctx.getFieldErrorValue('error')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.resetData.passwordResetToken)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_text_input, {
                              modelValue: _ctx.resetData.loginId,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resetData.loginId) = $event)),
                              label: "E-mail cím",
                              "error-msg": _ctx.getFieldErrorValue('loginId')
                            }, null, 8, ["modelValue", "error-msg"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_password_input, {
                                modelValue: _ctx.resetData.newPassword,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.resetData.newPassword) = $event)),
                                label: "Új jelszó",
                                "error-msg": _ctx.getFieldErrorValue('newPassword')
                              }, null, 8, ["modelValue", "error-msg"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_password_input, {
                                modelValue: _ctx.resetData.newPasswordConfirm,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.resetData.newPasswordConfirm) = $event)),
                                label: "Jelszó megerősítése",
                                "error-msg": _ctx.getFieldErrorValue('newPasswordConfirm')
                              }, null, 8, ["modelValue", "error-msg"])
                            ])
                          ], 64)),
                      _createElementVNode("button", {
                        class: "auth__button auth__button--primary",
                        disabled: !_ctx.checkRequiredFields()
                      }, " Küldés ", 8, _hoisted_22),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_router_link, { to: _ctx.loginUrl }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ], 32)
                  ], 64))
          ])
        ], 2)
      ])
    ])
  ]))
}